@if (isItem) {
    <button mat-icon-button mgdButton (click)="onEditItemClick()" [disabled]="disabled"><mat-icon>edit_note</mat-icon></button>
    <button mat-icon-button mgdBulkActionsButton (click)="onRemoveItemClick()" [disabled]="disabled"><mat-icon>playlist_remove</mat-icon></button>
}
@else if (isAdd || isRequiredText) {
    <button mat-icon-button mgdButton (click)="onAddItemClick()" [disabled]="disabled"><mat-icon>docs_add_on</mat-icon></button>
}
<ng-content></ng-content>
